'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _nestedtypes = require('nestedtypes');

var Nested = _interopRequireWildcard(_nestedtypes);

var _auroraJavascriptUtils = require('@unitedtraders/aurora-javascript-utils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var logger = _auroraJavascriptUtils.log.getLogger('nestedhateoas.backendSyncState');

// todo: review usage of `this.trigger'

// TODO(FVENDOR-6563): implement on state machine with access to promises

/**
 * Stores inner current state of synchronization of model/collection with rest backend
 * and promises, that execute synchronization procedure.
 * On success or errors, triggers events:
 *  - backendFetchSuccess
 *  - backendFetchFailure
 *  - backendSaveSuccess
 *  - backendSaveFailure
 *  - backendDeleteSuccess
 *  - backendDeleteFailure
 *
 * Prefix of field, determine operation (fetch* save* delete*)
 *
 * Accordingly operations *Promise will execute it
 * when *Promise pending:
 *  - *InProgress will equal TRUE,
 *
 * when *Promise proceed:
 *  - *InProgress will equal FALSE,
 *
 * when *Promise failed:
 *  - *InProgress will equal FALSE,
 *  - *Error will be filled
 */
var BackendSyncState = Nested.Model.extend({
    defaults: {
        fetchPromise: Object.value(null),
        fetchInProgress: Boolean.value(false),
        fetchError: Nested.value(null),

        savePromise: Object.value(null),
        saveInProgress: Boolean.value(false),
        saveError: Nested.value(null),

        deletePromise: Object.value(null),
        deleteInProgress: Boolean.value(false),
        deleteError: Nested.value(null)
    },

    _startFetch: function _startFetch(promise) {
        var _this = this;

        this.set({
            fetchInProgress: true,
            fetchPromise: promise,
            fetchError: null
        });

        promise.then(function () {
            return _this._fetchCompletedSuccess();
        }, function (error) {
            return _this._fetchCompletedWithError(error);
        });
    },
    _fetchCompletedSuccess: function _fetchCompletedSuccess() {
        this.set({
            fetchInProgress: false,
            fetchError: null
        });

        this.trigger('backendFetchSuccess', this.model);
    },
    _fetchCompletedWithError: function _fetchCompletedWithError(error) {
        this.set({
            fetchInProgress: false,
            fetchError: error
        });

        this.trigger('backendFetchFailure', this.model);

        logger.error('can\'t fetch model \'' + error + '\'');
    },
    _startSave: function _startSave(promise) {
        var _this2 = this;

        this.set({
            saveInProgress: true,
            savePromise: promise,
            saveError: null
        });

        promise.then(function () {
            return _this2._saveCompletedSuccess();
        }, function (error) {
            return _this2._saveCompletedWithError(error);
        });
    },
    _saveCompletedSuccess: function _saveCompletedSuccess() {
        this.set({
            saveInProgress: false,
            saveError: null
        });

        this.trigger('backendSaveSuccess', this.model);
    },
    _saveCompletedWithError: function _saveCompletedWithError(error) {
        this.set({
            saveInProgress: false,
            saveError: error
        });
        this.trigger('backendSaveFailure', this.model);

        logger.error('can\'t save model \'' + error + '\'');
    },
    _startDelete: function _startDelete(promise) {
        var _this3 = this;

        this.set({
            deleteInProgress: true,
            deletePromise: promise,
            deleteError: null
        });

        promise.then(function () {
            return _this3._deleteCompletedSuccess();
        }, function (error) {
            return _this3._deleteCompletedWithError(error);
        });
    },
    _deleteCompletedSuccess: function _deleteCompletedSuccess() {
        this.set({
            deleteInProgress: false,
            deleteError: null
        });

        this.trigger('backendDeleteSuccess', this.model);
    },
    _deleteCompletedWithError: function _deleteCompletedWithError(error) {
        this.set({
            deleteInProgress: false,
            deleteError: error
        });

        this.trigger('backendDeleteFailure', this.model);

        logger.error('can\'t delete model \'' + error + '\'');
    }
});

exports.default = BackendSyncState;


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/nested-hateoas/dist/BackendSyncState.js
// module id = 1407
// module chunks = 118